<script lang="ts">
  import type { DesignEditor } from '$src/application/designs/DesignEditor';
    import { CreateWallTool } from '$src/application/designs/rooms/CreateWallTool';
    import type { ITopViewCanvas } from '$src/domain/designs/editor/ITopViewCanvas';
    import { EditorSettings } from '$src/domain/designs/settings/EditorSettings';
    import { KonvaTopViewCanvas } from '$src/infrastructure/designs/editor/KonvaTopViewCanvas';
    import { onMount, onDestroy, getContext } from 'svelte';

    const editor : DesignEditor = getContext('editor');

    let container: HTMLDivElement;
    let canvas: ITopViewCanvas;
    let resizeObserver: ResizeObserver;
    let tool: CreateWallTool

    onMount(init);

    onDestroy(clean);

    function init() {
     
        canvas = new KonvaTopViewCanvas(container, new EditorSettings());
        editor.setTopViewCanvas(canvas);


        resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                if (entry.target === container) {
                    resizeCanvas();
                }
            }
        });

        resizeObserver.observe(container);
        resizeCanvas();

        //tool = new CreateWallTool(canvas);
    }

    function clean() {
        if( resizeObserver && container )  {
            resizeObserver.unobserve(container);
        }
    }

    function resizeCanvas() {
        if (container && canvas) {
            const width = container.clientWidth;
            const height = container.clientHeight;
            canvas.resizeCanvas(width, height);
        }
    }

    function addLine() {
        canvas.createLine({x: 10, y: 10}, {x: 100, y: 150});
    }

</script>

<div class="canvas-view-zone" bind:this={container}>

</div>

<style>
 
    .canvas-view-zone {
        /* flex: 1;
        position: relative;
        z-index: 2; */
        width: 100%;
        flex-grow: 1; 
        z-index: 9;
    }
</style>